import './Progetto.css';
import ProgettoNav from './ProgettoNav';

function Progetto5() {
    return (
        <div className='progetto-container'>
            <ProgettoNav prevPath='/progetto-biblioteche' />
            <h1 className='progetto-title'>RELAZIONE PROGETTO</h1>
            <h2 className='progetto-subtitle'><strong><u><i>"A spasso per il Friuli Venezia Giulia – una (altra?) storia da raccontare"</i></u></strong></h2>

            <h3>AMBITO PRIORITARIO</h3>
            <p>
                Il progetto "<i>A spasso per il Friuli Venezia Giulia – una (altra?) storia da raccontare</i>" ricade
                ed è stato pensato nell'ambito delle finalità statutarie dell'Associazione Settemotivi.
            </p>
            <p>
                Il progetto, sviluppato tra il mese di novembre 2025 e maggio 2026, aveva ed ha come obiettivo di
                far conoscere attraverso il programma radiofonico, il territorio del Friuli Venezia Giulia.
            </p>

            <p>
                Il Friuli Venezia Giulia è un territorio dove c'è ancora tanto da scoprire ed ogni volta che lo
                rivedi noti sempre dei dettagli nuovi. Dal mare alla montagna passando per le pianure e non solo,
                angoli, anfratti, luoghi insoliti non contemplati nei libri, ma ricchi di storia, cultura e
                tradizioni da riscoprire e da far rivivere.
            </p>
            <p>
                Proprio per questo motivo si è scelto di far conoscere le meraviglie del Friuli Venezia Giulia
                anche a quelle persone che, impossibilitate al viaggio, ma curiose del sapere, attraverso la
                nostra serie radiofonica "A spasso per il Friuli Venezia Giulia – una (altra?) storia da
                raccontare" sono state prese per mano ed accompagnate nei territori dei Comuni delle Provincie
                di Gorizia, Pordenone, Udine e Trieste; dai murales di Giulio Masiero alle meridiane di Aurelio
                Pantanaliper non dimenticare i "Cammini", dei quali questa Regione è molto ricca.
            </p>
            <p>
                Ogni puntata iniziava narrando le origini e la storia di ogni luogo, storie tratte da antica
                documentazione o da racconti tramandati verbalmente dagli abitanti del posto.
            </p>
            <p>
                Ogni paese oltre alla propria storia ha anche numerose tradizioni, soprattutto nei Paesi immersi
                nella natura si è parlato di botanica e degli antichi rimedi che si preparavano in casa; sono
                state suggerite ricette locali, si sono ascoltate le melodie di vecchi successi di chi è stato
                sulla cresta dell'onda e di chi è emergente. Oltre a raccontare il passato si è posta particolare
                attenzione su quello che oggi offre il territorio; si è parlato di arte e di cultura, dando
                indicazione dei percorsi da seguire per raggiungere "le bellezze" di cui si è parlato.
            </p>
            <p>
                Non sono mancate le richieste di informazioni da parte dei radio ascoltatori che avevano solo
                letto di alcune località chiedendo ad esempio quale fosse il periodo migliore per visitare i
                posti. Non sono mancate le richieste dei costi, per quelli sono state indirizzate agli uffici
                preposti. Il nostro compito è stato quello di raccontare, ma soprattutto di scaturire la
                curiosità delle persone, obiettivo ampiamente "centrato".
            </p>
            <p>
                Si è raggiunto un numero molto elevato di persone considerato che, le puntate sono state
                trasmesse in una Radio digitale (webradio), che non ha limitazioni territoriali. I programmi si
                sono potuti ascoltare in tutte le Regioni d'Italia e anche oltre i confini.
            </p>
            <p>
                Attraverso il nostro progetto, che si può considerare una "guida", abbiamo creato interazioni
                con un nuovo pubblico "curioso" e non solamente locale; un turista che abbia già in mente cosa
                trova e cosa lo sorprenda, in luoghi che soddisfano tutti i tipi di esigenze, sia per una
                semplice passeggiata, una visita ai luoghi culturali, un'attività sportiva o perché no, la
                degustazione delle prelibatezze locali nei ristoranti tipici, non rimarrà sicuramente deluso.
            </p>
            <p>
                Sono state raccolte, anche in loco nel territorio individuato, tutte le notizie necessarie
                (testimonianze, documenti storici, aneddoti), al fine di una curiosa, accattivante e soprattutto
                che corrisponda alla realtà.
            </p>

            <h3>Obiettivo</h3>
            <p className='progetto-left'>
                La divulgazione di informazioni, se non su tutto, su una parte del territorio regionale per far
                crescere in chi ascolta la conoscenza e il desiderio di viverlo.
            </p>

            <h3>Fascia di età a cui è rivolto</h3>
            <p>Il progetto realizzato si rivolge a tutte le età</p>

            <h3>Programmazione Radiofonica</h3>
            <p>Tutte le puntate sono state trasmesse in radio.</p>
            <p>Le stesse verranno riproposte in replica nei prossimi mesi per dare ancora risalto al progetto.</p>
            <p>
                Al progetto è stata data diffusione mediante uno spot pubblicitario che è andato in onda per
                tutto il periodo del progetto.
            </p>
            <p>Parimenti la pubblicità è stata veicolata nel proprio sito web e sui social.</p>

            <h3>Durata del progetto</h3>
            <p>Il progetto è stato realizzato dal 1° novembre 2025 al 31 maggio 2026.</p>

            <h3>Estensione territoriale</h3>
            <p>Il progetto ha coinvolto direttamente i comuni delle provincie di Pordenone – Udine – Gorizia e Trieste</p>

            <h3>Convenzioni e Partner</h3>
            <p>Nell'ambito del progetto è non stata attiva nessuna convenzione.</p>
            <p>Nessun partner coinvolto nel progetto.</p>

            <h3>Volontari coinvolti</h3>
            <p>
                I volontari coinvolti nel progetto nel periodo 1° novembre 2025 – 31 maggio 2026 sono in numero
                di tre in periodi diversi.
            </p>

            <ProgettoNav prevPath='/progetto-biblioteche' />
        </div>
    );
}

export default Progetto5;
